// Automatic Offline -> Online Sync Engine

import { api } from "./api";
import { getPendingOfflineOrders, markOrderSynced } from "./offlineDb";

let isSyncing = false;
let syncListeners = [];

export function subscribeSyncStatus(listener) {
  syncListeners.push(listener);
  return () => {
    syncListeners = syncListeners.filter((l) => l !== listener);
  };
}

function notifySyncListeners(event) {
  for (const listener of syncListeners) {
    try {
      listener(event);
    } catch (e) {
      console.error("Sync listener error:", e);
    }
  }
}

export function isOnline() {
  return typeof navigator !== "undefined" ? navigator.onLine : true;
}

export async function syncOfflineOrders() {
  if (isSyncing) return;
  if (!isOnline()) return;

  const pending = await getPendingOfflineOrders();
  if (!pending.length) return;

  isSyncing = true;
  notifySyncListeners({ type: "SYNC_START", count: pending.length });

  let successCount = 0;
  let failCount = 0;

  for (const order of pending) {
    try {
      // Build order payload for server
      const payload = {
        customer_name: order.customer_name || "Walk-in Guest",
        phone: order.phone || "",
        table_no: order.table_no || "",
        order_type: order.order_type || "dine-in",
        payment_mode: order.payment_mode || "cash",
        items: order.items || [],
        address: order.address || "",
        notes: order.notes || "",
        offline_no: order.offline_id, // Pass offline number for idempotency
      };

      const res = await api.post("/orders", payload);
      await markOrderSynced(order.offline_id, res.data);
      successCount++;
    } catch (err) {
      console.error(`Failed to sync offline order ${order.offline_id}:`, err);
      failCount++;
    }
  }

  isSyncing = false;
  notifySyncListeners({
    type: "SYNC_COMPLETE",
    synced: successCount,
    failed: failCount,
  });

  return { successCount, failCount };
}

// Auto-initialize online status listener
export function initSyncEngine() {
  if (typeof window !== "undefined") {
    window.addEventListener("online", () => {
      console.log("Internet connection restored. Triggering sync...");
      syncOfflineOrders();
    });

    // Run initial sync check on mount if online
    if (isOnline()) {
      setTimeout(() => {
        syncOfflineOrders();
      }, 3000);
    }
  }
}
